import { render, staticRenderFns } from "./NewDataNote.vue?vue&type=template&id=2fa2ef20&scoped=true&"
import script from "./NewDataNote.vue?vue&type=script&lang=js&"
export * from "./NewDataNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa2ef20",
  null
  
)

export default component.exports